import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { toast } from "react-toastify";
import { Constants } from "../utils";
import { Storage } from "../storage";
import { AuthService } from "./auth";

const api = axios.create({
    baseURL: Constants.urls.base
})

export default api